import type { FaireProductEntity } from "../../entity_types/product";

export const p_gehjvh9rv2: FaireProductEntity = {
  token: "p_gehjvh9rv2",
  type: "product",
  name: "Sweet Ghost Halloween Sweater - Kids Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/3f79ed8365620218d7353c7d19abcdbd1cc8aa9199c178d4a11f23e7d0508c66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69e3a00148005807aaccdab35170797f1bec98c303cebb2dd312680e6f9b06a4.jpeg",
    "https://cdn.faire.com/fastly/99b8c45144969769c2490ad900e0d3180cde9e48b0b50f935f75465ad7dbd3d3.jpeg",
    "https://cdn.faire.com/fastly/b5e4000e201dac7929be2904dcac29da8364bd3973eafc791aaf22f3be482243.jpeg",
    "https://cdn.faire.com/fastly/2313a04c9e728a8bbcc018057e4791b5252f8f9bd27a1d11f32e99a02e3e89ae.jpeg",
    "https://cdn.faire.com/fastly/4d5fa3c52b632bff0a587c4c5496209bc99ee7c3cfaeea0a122982b26f3b3cdc.jpeg",
    "https://cdn.faire.com/fastly/3a1eaef428d0e8dddd4d2fcff2660e2cd4303a1ff73b8b5c72960236fcdfe180.jpeg",
  ],
  priceDollars: 33,
  description:
    "Friendly ghosts have never looked so cute! This cozy pink sweater brings playful Halloween fun with the sweetest girly twist.\n\nFeatures:\n * Sweater Color: Soft pink with a white ghost accented with a black satin bow \n * Material: 50% Viscose, 30% Polyester, 20% Nylon \n * Fit: True to size \n * Care: Hand wash only, do not iron, tumble dry, bleach or dry clean \n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:30.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
